import { render, staticRenderFns } from "./ReferralInfoModal.vue?vue&type=template&id=ef9a6c5a&scoped=true"
import script from "./ReferralInfoModal.vue?vue&type=script&lang=js"
export * from "./ReferralInfoModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralInfoModal.vue?vue&type=style&index=0&id=ef9a6c5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9a6c5a",
  null
  
)

export default component.exports